/** @format */
import * as yup from "yup";



export const accountSchema = yup.object().shape({
  accountNumber: yup.string().required("Account number is required"),
  bankName: yup.string().required("Bank name is required"),
  accountName: yup.string().required("Account name is required"),

});
